import React from 'react';
import styled from 'styled-components';

import { h1Styles } from 'partials/typography';
import css from 'css';

export default props => {
    const { data, pageBackground } = props;

    return (
        <NumbersWidget pageBackground={pageBackground}>
            {data.map((row, i) => {
                return (
                    <div key={i}>
                        <strong>{row.number}</strong>
                        <span>{row.description}</span>
                    </div>
                );
            })}
        </NumbersWidget>
    );
}

const NumbersWidget = styled.li`
    div {
        margin-bottom:50px;
        strong {
            display: block;
            ${h1Styles}
            ${props => props.pageBackground === 'main' ? `
                color: ${css.colors.pink};
            ` : ``}
        }
        span {
            display: block;
            ${props => props.pageBackground === 'main' ? `
                color: #fff;
            ` : ``}
        }
    }
`



// WEBPACK FOOTER //
// ./src/partials/modules/RichText/NumbersWidget.js